module.exports = __webpack_public_path__ + "static/media/zheng8@3x.46248a83.png";